export default __webpack_public_path__ + "static/media/lato-blackitalic.ec051bce.woff";